import Constants from '../../constants/column-name/customer.column-name.constants';

export default {
  ThirdParty: {
    store: 'ThirdParty',
    lookups: {
      idField: 'thirdPartyName',
      codeField: 'thirdPartyName',
      nameField: 'thirdPartyName'
    },
    formProps: {
      idField: Constants.customerThirdParty.field,
      codeField: Constants.customerThirdParty.field,
      nameField: Constants.customerThirdParty.field
    },
    isServerSide: true,
    serverSearchKey: 'ThirdPartySearchFieldQuery',
    searchOnOpen: true
  }
};
